(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anglo-auto-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anglo-auto-faq')) {
 customElements.define('anglo-auto-faq', class extends HTMLElement {
  connectedCallback() {
   this.openLinkedAnswer = () => {
    const target = Array.from(this.querySelectorAll('details[id]')).find(answer => '#' + answer.id === window.location.hash);
    if (target) target.open = true;
   };
   this.openLinkedAnswer();
   window.addEventListener('hashchange', this.openLinkedAnswer);
  }
  disconnectedCallback() {
   window.removeEventListener('hashchange', this.openLinkedAnswer);
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["anglo-auto-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anglo-auto-promo')) {
 customElements.define('anglo-auto-promo', class extends HTMLElement {
  connectedCallback() {
   if (this.timer) return;
   const start = Date.parse(this.dataset.start);
   const end = Date.parse(this.dataset.end);
   const form = document.getElementById(this.dataset.form);
   const redirect = form?.querySelector('[data-auto-return]');
   const clock = this.querySelector('[data-auto-countdown]');
   const valid = Number.isFinite(start) && Number.isFinite(end) && end - start === 1800000;
   this.refresh = () => {
    const now = Date.now();
    const active = valid && now >= start && now < end;
    this.hidden = !active;
    if (redirect) redirect.value = active ? this.dataset.path : redirect.dataset.default;
    if (!active) {
     if (this.timer) clearInterval(this.timer);
     this.timer = null;
     return;
    }
    const remaining = Math.ceil((end - now) / 1000);
    clock.textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
   };
   this.form = form;
   form?.addEventListener('submit', this.refresh);
   this.timer = setInterval(this.refresh, 1000);
   this.refresh();
  }
  disconnectedCallback() {
   if (this.timer) clearInterval(this.timer);
   this.timer = null;
   this.form?.removeEventListener('submit', this.refresh);
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["anglo-auto-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('anglo-auto-buy')) {
 customElements.define('anglo-auto-buy', class extends HTMLElement {
  connectedCallback() {
   if (this.dataset.initialized) return;
   this.dataset.initialized = 'true';
   const image = this.querySelector('.auto-main-image');
   const setImage = (src, alt) => {
    if (!image || !src) return;
    image.src = src;
    image.removeAttribute('srcset');
    image.alt = alt;
   };
   const variants = this.querySelectorAll('[data-auto-variant]');
   const site = this.closest('.auto-site');
   const update = option => {
    const available = option.dataset.available === 'true';
    this.querySelector('[data-auto-price]').textContent = option.dataset.price;
    const saving = this.querySelector('[data-auto-saving]');
    if (saving) { saving.textContent = option.dataset.saving || ''; saving.hidden = !option.dataset.saving; }
    const compare = this.querySelector('[data-auto-compare]');
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    site.querySelectorAll('[data-auto-sticky-price]').forEach(element => element.textContent = option.dataset.price);
    site.querySelectorAll('[data-auto-sticky-variant]').forEach(element => element.textContent = option.dataset.title);
    site.querySelectorAll('[data-auto-add]').forEach(button => button.disabled = !available);
    site.querySelectorAll('[data-auto-add-label]').forEach(label => label.textContent = available ? this.dataset.add : this.dataset.sold);
    this.querySelector('[data-auto-availability]').textContent = option.dataset.status;
    if (option.dataset.image) setImage(option.dataset.image, image ? image.alt : option.dataset.title);
   };
   variants.forEach(option => option.addEventListener('change', () => { if (option.checked) update(option); }));
   const checked = this.querySelector('[data-auto-variant]:checked');
   if (checked) update(checked);
   const form = this.querySelector('form');
   const sticky = site.querySelector('[data-auto-sticky]');
   if (sticky && 'IntersectionObserver' in window) {
    this.observer = new IntersectionObserver(entries => {
     const entry = entries[0];
     sticky.classList.toggle('is-active', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    });
    this.observer.observe(form);
   }
  }
  disconnectedCallback() {
   if (this.observer) this.observer.disconnect();
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["anglo-auto-reviews"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
 const button = event.target.closest('[data-review-step]');
 if (!button) return;
 const list = button.closest('.auto-reviews')?.querySelector('.jdgm-review-list');
 const card = list?.querySelector('.jm-review-item');
 if (!list || !card) return;
 const gap = parseFloat(getComputedStyle(list).gap) || 14;
 list.scrollBy({left: Number(button.dataset.reviewStep) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
});
  } catch(e) { console.error(e); }
})();

})();
